import { useContext } from 'react';
import { SizePassportContext } from '../contexts/SizePassportContext';

const useSizePassportContext = () => {
  const context = useContext(SizePassportContext);

  if (!context) {
    throw new Error('useSizePassportContext must be used within a SizePassportContextProvider');
  }

  return context;
};

export default useSizePassportContext;
